<template>
  <v-app class="home_background" :class="extendedSize">
    <v-row fluid class="fill-height home_container">
      <v-col cols="12" xs="12" sm="12" md="4" lg="6"> </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="8"
        lg="6"
        class="home_right"
        style="background-color: rgba(255,0,0,0.1)"
      >
        <div class="home_logo">
          <img src="@/assets/images/logo_white.svg" />
        </div>
        <v-card outlined class="home_card">
          <v-tabs active-class="activo" fixed-tabs v-model="tab">
            <v-tab class="tabs" :href="`#tab-1`">Iniciar sesión</v-tab>
            <v-tab class="tabs" :href="`#tab-2`">Regístrate</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" touchless>
            <v-tab-item :value="'tab-1'" class="container__tabs">
              <user-login></user-login>
            </v-tab-item>
            <v-tab-item :value="'tab-2'" class="container__tabs">
              <user-register></user-register>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-app>
</template>
<script>
import UserRegister from "@/containers/users/UserRegister";
import UserLogin from "@/containers/users/UserLogin";

export default {
  components: {
    "user-register": UserRegister,
    "user-login": UserLogin,
  },
  data() {
    return {
      tab: 0,
      extendedSize: "",
    };
  },
  watch: {
    tab(value) {
      //console.log(value);
      if (value == "tab-2") {
        this.extendedSize = "home_extended";
      } else {
        this.extendedSize = "";
      }
    },
  },
};
</script>
